import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Dialog from "primevue/dialog";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UDialog',
    props: {
        visible: { type: Boolean },
        title: {},
        height: {}
    },
    emits: ["update:visible"],
    setup(__props, { emit: __emit }) {
        const emits = __emit;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Dialog), {
                visible: __props.visible,
                modal: "",
                style: _normalizeStyle({ width: '480px', height: __props.height }),
                header: __props.title,
                "onUpdate:visible": _cache[0] || (_cache[0] = v => emits('update:visible', v))
            }, {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                _: 3
            }, 8, ["visible", "style", "header"]));
        };
    }
});
